import { inboxesConstants } from 'store/constants';
import { inboxesService } from 'store/services/inboxes.service';
import { alertsActions, workdeskFilterActions } from '.';
import getErrorMessage from 'utils/getErrorMessage';
import { selectedInboxesListSelector } from 'store/selectors/workdesk-filter.selector';

const getInboxes = () => {
  const request = () => {
    return {
      type: inboxesConstants.INBOXES_REQUEST,
    };
  };
  const failure = (error: string) => {
    return {
      type: inboxesConstants.INBOXES_ERROR,
      payload: { error },
    };
  };
  const success = (inboxes) => {
    return {
      type: inboxesConstants.INBOXES_SUCCESS,
      payload: { inboxes },
    };
  };
  return async (dispatch, getState) => {
    dispatch(request());
    try {
      const data = await inboxesService.getInboxes();
      // if any inboxes in the selectedInboxes not in the data
      const inboxes = data.map((d) => d.address);
      const selectedInboxes = selectedInboxesListSelector(getState());
      const anyNotInInboxes = selectedInboxes.filter(
        (inbox) => !inboxes.includes(inbox),
      );
      if (anyNotInInboxes.length > 0) {
        const inOnly = selectedInboxes.filter((inbox) =>
          inboxes.includes(inbox),
        );
        dispatch(
          workdeskFilterActions.setSelectedInboxes(inOnly, true),
        );
      }
      // update the inboxes in the store
      // IMPORTANT: must do it after set the selected inboxes not before
      dispatch(success(data));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};
export const inboxesActions = {
  getInboxes,
};
